import React, { useCallback, useState, useEffect, useContext } from 'react';
import moment from 'moment';
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { isCapabilityEnabled } from 'gw-portals-config-js';
import { useValidation } from 'gw-portals-validation-react';
import { PolicyChange, messages } from 'gw-capability-policychange-common-react';
import { Loader } from '@jutro/components';

// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { ViewModelServiceContext, withViewModelService } from 'gw-portals-viewmodel-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './AddressPage.metadata.json5';
import styles from '../../BAPolicyChange.module.scss';
import './AddressPage.messages';
import AddressComponent from "../../../nexus-capability-gateway-react/Components/Address/AddressComponent";
import {AdditionalInsuredInterestComponent } from 'gw-capability-policychange-ho-react';
import { AccountContactSearchComponent } from '../../../nexus-capability-gateway-react';
import _ from 'lodash';
import {GatewayEndorsementService as EndorsementService} from 'gw-capability-gateway-policychange';
import { ServiceManager } from '@jutro/services';

const { capabilitiesConfig } = appConfig;

function AddressPage(props) {
    const { wizardData, updateWizardData, authHeader } = props;
    let { submissionVM, updateGarageLocation } = wizardData;
    if (!submissionVM) {
        submissionVM = wizardData;
    }
    const { AvailabilityService } = useDependencies('AvailabilityService');
    const { EndorsementService } = useDependencies('EndorsementService');
    const viewModelService = useContext(ViewModelServiceContext);
    const localeService = ServiceManager.getService('locale-service');
    const { onValidate, initialValidation, isComponentValid } = useValidation(
        'BAPolicyChangeAddressPage'
    );
    const [accountContacts, setAccountContacts] = useState([{}]);
    const [location, setLocation] = useState("");
    const [addLocation, setAddLocation] = useState(false);
    const [editLocation, setEditLocation] = useState(false);
    const [locationVM, setLocationVM] = useState({});
    const [policyLocations, setPolicyLocations] = useState([]);
    const primaryAddress = submissionVM.baseData.policyAddress.value;
    const keysToMatch = ['addressLine1', 'addressLine2', 'addressLine3','city','country', 'postalCode','state'];
    const [isLoading, setIsLoading] = useState(false);
    const [isAllSameGaragedAt, setIsAllSameGaragedAt] = useState('');
    const [isAddressEdited, setAddressEdited] = useState(false);
    const [isBmsClientCodeEditable, setIsBmsClientCodeEditable] = useState(true);

    useEffect(()=>{
        if(!_.get(submissionVM, 'baseData.termTypeAuto.value')){
            submissionVM.baseData.termType.value = 'Annual';
        }
        const _contacts = submissionVM.baseData.account.accountContacts.value.map((c) => {
            c['id'] = c.publicID;
            return c;
        });
        _contacts.push({ id: "placeholder", displayName: "Search Existing Contacts" });
        setAccountContacts(_contacts);
        if(policyLocations.length== 0)  {  
            EndorsementService.getPolicyLocations(
                [submissionVM.jobID.value],
                authHeader
            ).then((locations) => {
                const _locations = locations.map((c) => {
                    c['id'] = c.accountPublicID;
                    return c
                });
                setPolicyLocations(_locations);
                const matchingLocation = _.filter(_locations, (location) => {
                    const addressChanged =  _.filter(keysToMatch, (a) => {return primaryAddress[a] != location[a]}).length > 0;
                    return !addressChanged;
                });
                const vehicles = submissionVM.lobData.businessAuto.coverables.vehicles.value
                var macthingGaragedAtLocationsCount =matchingLocation.length > 0 ? _.filter(vehicles,(v) => {
                    return matchingLocation[0].id == v.garagedAt
                }).length : 0
                if(vehicles.length == macthingGaragedAtLocationsCount){
                    setIsAllSameGaragedAt(matchingLocation[0].id);
                    submissionVM.lobData.businessAuto.coverables.updateGarageLocation = true;
                }
                else{
                    setIsAllSameGaragedAt(false);
                }
                
                if(matchingLocation.length > 0){
                    const id = matchingLocation[0].id;
                    setLocationVM(createLocationVM(matchingLocation[0]));
                    setLocation(id);
                }                
            }); 
        } 
        
    }, [submissionVM, policyLocations])

    const onAddressChange = (value, path) => {
        _.set(wizardData, `submissionVM.baseData.policyAddress.${path}`, value);
        updateWizardData(wizardData);
    }

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            addressComponent: AddressComponent,
            additionalInsuredInterestComponent: AdditionalInsuredInterestComponent,
            accountContactSearch: AccountContactSearchComponent
        },
    };

    const onNext = useCallback(async () => {
        try{
            let response = { isAvailable: true };
            const matchingLocation = _.filter(policyLocations, (location) => {
                const addressChanged =  _.filter(keysToMatch, (a) => {return primaryAddress[a] != location[a]}).length > 0;
                return !addressChanged;
            })
            const updatedMailingAddress = matchingLocation.length == 0    
            
            if (updatedMailingAddress && isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'policycommon' })) {
                const availabilityDTO = {
                    address: submissionVM.baseData.policyAddress.value,
                    effectiveDate: moment(submissionVM.baseData.effectiveDate.value).format(),
                    productCode: submissionVM.baseData.productCode.value,
                    accountNumber: submissionVM.baseData.accountNumber.value
                };
                response = await AvailabilityService.checkAvailabilityBasedOnAddress(
                    availabilityDTO,
                    authHeader
                );
            }
            if (response.isAvailable) {
                submissionVM.value.beforeSave();
                if(!updatedMailingAddress && submissionVM.lobData.businessAuto.coverables.updateGarageLocation.value){
                    _.forEach(submissionVM.lobData.businessAuto.coverables.vehicles.children, (vehicle) => {
                        vehicle.garagedAt.value = location;
                    })
                }
                //submissionVM.lobData.businessAuto.coverables.updatedMailingAddress.value = false;
                const policyChangeResponse = await EndorsementService.saveEndorsement(
                    [submissionVM.value],
                    authHeader
                );
                submissionVM.value = new PolicyChange(policyChangeResponse);
            }
            return wizardData;
        }
        catch(err){
            console.log(err);
        }
        
    }, [EndorsementService, AvailabilityService, submissionVM, authHeader, wizardData, policyLocations,location]);

    const onBrokerClientCodeChange = (value, index) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, `baseData.brokerClientCode.value`, value);
       _.set(wizardData, 'submissionVM', newSubmissionVM);
        updateWizardData(wizardData);
    };

    const updateAdditionalInsured = (value, index) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, `baseData.additionalNamedInsureds.children.${index}.value`, value);
       _.set(wizardData, 'submissionVM', newSubmissionVM);
        updateWizardData(wizardData);
    };

    const writeAdditionalInsuredValue = useCallback(
        (value, path) => {
            _.set(submissionVM, `baseData.${path}`, value);
            _.set(wizardData, 'submissionVM', submissionVM);
            updateWizardData(wizardData);
        },
        [submissionVM, updateWizardData]
    );

    const updatePackage = (value, index) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        // _.set(newSubmissionVM, `lobData.homeowners.allCoverables.children.${index}.value`, value);
        //_.set(wizardData, 'submissionVM', newSubmissionVM);
        updateWizardData(newSubmissionVM);
    };

    const updateSubmission = (newSubmissionVM) => {
        _.set(wizardData, 'submissionVM', newSubmissionVM);
        updateWizardData(wizardData);
    };

    const writeValue = useCallback(
        (value, path) => {
            _.set(submissionVM, path, value);
            if (path === 'baseData.termTypeAuto' || path === 'baseData.periodStartDate'){
                const term = _.get(submissionVM, 'baseData.termTypeAuto.value');
                const startDate = _.get(submissionVM, 'baseData.periodStartDate.value');
                let endDate = null;
                if (term.code === 'HalfYear') {
                    endDate = new Date(new Date(startDate.year, startDate.month, startDate.day).setMonth(new Date(startDate.year, startDate.month, startDate.day).getMonth() + 6));
                } else {
                    endDate = new Date(new Date(startDate.year, startDate.month, startDate.day).setMonth(new Date(startDate.year, startDate.month, startDate.day).getMonth() + 12));
                }
                endDate = { year: endDate.getFullYear(), month: endDate.getMonth(), day: endDate.getDate() };
                _.set(submissionVM, 'baseData.periodEndDate', endDate);
            }
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    const createLocationVM = (model) => {
        const _locationVM = viewModelService.create(
            model,
            'pc',
            'edge.capabilities.policyjob.helper.PolicyLocationDTO'
        );
        return _locationVM
    };

    const handleAddNewLocation = () => {
        const model = { country: localeService.getDefaultCountryCode(), state: 'ON' };
        setLocationVM(createLocationVM(model));
        setAddLocation(true);
        setEditLocation(false);

    };

    const handleEditNewLocation = () => {         
        const matchingLocation = _.filter(policyLocations, (location) => {
            const addressChanged =  _.filter(keysToMatch, (a) => {return primaryAddress[a] != location[a]}).length > 0;
            return !addressChanged;
        });
        if(matchingLocation.length > 0){
            const id = matchingLocation[0].id;
            setLocationVM(createLocationVM(matchingLocation[0]));
            setLocation(id);
        }
        _.forEach(keysToMatch, (a) => { 
            submissionVM.baseData.policyAddress.value[a] = matchingLocation[0][a]
        })       
        setAddLocation(false);
        setEditLocation(true);
    };

    const cancelPackageLocationUpdate = async () => {
        setAddLocation(false);
        setEditLocation(false);
    }

    const createUpdatePackageLocation = async () => {
        setIsLoading(true);
        let updatedLocation = {}
        updatedLocation = await EndorsementService.createOrUpdatePolicyLocation([submissionVM.jobID.value, locationVM.value], authHeader);
        setLocation(updatedLocation.publicID);
        let updatedLocations = [];
        updatedLocations = await EndorsementService.getPolicyLocations([submissionVM.jobID.value], authHeader);
        updatedLocations = updatedLocations.map((c) => {
            c['id'] = c.accountPublicID;
            return c
        });
        setPolicyLocations(updatedLocations);
        try{            
            _.forEach(keysToMatch, (a) => {return submissionVM.baseData.policyAddress[a] = updatedLocation[a]});
            const policyChangeResponse = await EndorsementService.saveEndorsement(
                [submissionVM.value],
                authHeader
            );
            submissionVM.value = new PolicyChange(policyChangeResponse);
        }
        catch(err){
            console.log(err);
        }
        const matchingLocation = _.filter(updatedLocations, (location) => {
            const addressChanged =  _.filter(keysToMatch, (a) => {return primaryAddress[a] != location[a]}).length > 0;
            return !addressChanged;
        });
        if(matchingLocation.length > 0){
            const id = matchingLocation[0].id;
            setLocationVM(createLocationVM(matchingLocation[0]));
            setLocation(id);
        } 
        if(editLocation && isAllSameGaragedAt && (isAllSameGaragedAt == location)){
            submissionVM.lobData.businessAuto.coverables.updateGarageLocation = true;
            setAddressEdited(true)
        }
        else{
            setAddressEdited(false)
        }
        //setPolicyLocations(updatedLocations);
        setAddLocation(false);
        setEditLocation(false);
        setIsLoading(false);
    }

    const OnAddressValueChange = (value, path) => {
        const newLocationVM = viewModelService.clone(locationVM);
        _.set(newLocationVM, path, value);
        setLocationVM(newLocationVM);
        if(editLocation){
            onAddressChange(value, path);
        }
    }

    const onLocationChange = (value) => {
        const _location = value;
        const selectedLocation = policyLocations.filter((loc) => { return loc.id == value })[0];
        _.forEach(keysToMatch, (a) => { 
            submissionVM.baseData.policyAddress.value[a] = selectedLocation[a];
        })
        setLocation(_location);
    };

    const insureds = submissionVM.baseData.additionalNamedInsureds.value.map((c) => { return c.accountPublicId });
    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            showOptional: false,
            showRequired: true
        },
        // policyAddressComponent: {
        //     model: submissionVM.baseData.policyAddress,
        //     //hideFields: ['addressLine3'],
        //     onValueChange: onAddressChange
        // },
        garageAddress:{
            onValueChange: (value, path) => {
                wizardData.updateGarageLocation = value;
                _.set(wizardData, path, value);
                updateWizardData(wizardData);
            },
            defaultValue: updateGarageLocation,
            disabled: isAddressEdited && (submissionVM.lobData.businessAuto.coverables.vehicles.value.length == 1)
        },
        accountContactSearchId: {
            submissionVM: submissionVM,
            accountContacts: submissionVM.baseData.account.accountContacts,
            accountNumber: submissionVM.baseData.accountNumber,
            updatePackage: updatePackage,
            authHeader: authHeader,
            onValueChange: writeValue,
            updateWizardData: updateWizardData,
            isPolicyChange: true,
            updateSubmission: updateSubmission

        },
        additionalInsured: {
            coverableVM: submissionVM.baseData,
            accountContacts: accountContacts,
            accountNumber: submissionVM.baseData.accountNumber.value,
            type: 'additionalInsured',
            updatePackage: updateAdditionalInsured,
            authHeader: authHeader,
            onValueChange: writeAdditionalInsuredValue,
            isSubmission: false,
            jobID: submissionVM.jobID.value,
            updateAccountContacts: setAccountContacts,
            availableValues: submissionVM.baseData.account.accountContacts.value.filter( (c) => {
                return insureds.indexOf(c.publicID) == -1
            } ).map( (c) => {
                c['id'] = c.publicID;
                return c;
            }),
        },
        policyLocationSelect: {
            availableValues: policyLocations,
            onValueChange: onLocationChange,
            value: location,
            disabled: addLocation || editLocation
        },
        editNewLocationButton: {
            onClick: handleEditNewLocation,
            disabled: addLocation || editLocation
        },
        addNewLocationButton: {
            onClick: handleAddNewLocation,
            disabled: addLocation || editLocation
        },
        addressLookupComponent: {
            visible: addLocation || editLocation,
            model: locationVM,
            hideFields: ['addressType'],
            readOnlyFields: ['country'],
            onValueChange: OnAddressValueChange,
            showCounty: true
        },
        addressLookupButtonContainer: {
            visible: addLocation || editLocation,
        },
        addAddressButton: {
            onClick: createUpdatePackageLocation,
            visible: addLocation
        },
        saveAddressButton: {
            onClick: createUpdatePackageLocation,
            visible: editLocation
        },
        cancelAddressButton: {
            onClick: cancelPackageLocationUpdate
        },
        bmsClientCode: {
            visible : isBmsClientCodeEditable,
            readOnly : true,
            value: submissionVM.baseData.brokerClientCode.value ? submissionVM.baseData.brokerClientCode.value : null,
        },
        editBmsClientCode : {
            onClick : ()=>{
                setIsBmsClientCodeEditable(false);
            },
            visible : isBmsClientCodeEditable,
        },
        bmsClientCodeEditable : {
            visible : !isBmsClientCodeEditable,
            value: submissionVM.baseData.brokerClientCode.value ? submissionVM.baseData.brokerClientCode.value : null,
            onValueChange: onBrokerClientCodeChange,
            onBlur : ()=>{
                setIsBmsClientCodeEditable(true);
            },
        }
    };

    return (
        <WizardPage
            onNext={onNext}
            cancelLabel={(appConfig.persona === 'policyholder' ? messages.cancelAllChanges : messages.cancel)}
            disableNext={!isComponentValid}
            skipWhen={initialValidation}
            showPrevious
        >
            <Loader loaded={!isLoading}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={wizardData}
                    overrideProps={overrideProps}
                    onModelChange={updateWizardData}
                    classNameMap={resolvers.resolveClassNameMap}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    onValidationChange={onValidate}
                />
            </Loader>
        </WizardPage>
    );
}

AddressPage.propTypes = wizardProps;
export default withAuthenticationContext(AddressPage);
